import { httpClient } from '../../../../search-library/src/utils/http';
import { logger } from '../../utils/logger';

const SESSION_KEY = 'fss.sessionToken';

async function getToken(): Promise<void> {
  let token = sessionStorage.getItem(SESSION_KEY);
  logger.log('Verifying token.');
  const isTokenValid = token ? await verifyToken(token) : false;

  // Don't do anything when token is still valid
  if (isTokenValid) {
    logger.log('Existing token is valid.');
    return undefined;
  }

  // Get a new token
  logger.log('Token is not valid. Fetching a new one');
  token = await fetchToken();

  // Persist token
  storeToken(token);
  logger.log('New token was persisted');
}

/**
 * verifyToken: used to verify token stored in the localStorage
 */
async function verifyToken(tokenId: string): Promise<boolean> {
  try {
    await httpClient.get('/sessions/verify', { params: { tokenId: tokenId } });
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * fetchToken: retrieve a new token when no token was previously stored or the one found is invalid
 */
async function fetchToken(): Promise<string> {
  try {
    const { data } = await httpClient.post('/sessions');
    return data.token;
  } catch (error) {
    throw new Error('Unable to fetch session token');
  }
}

function storeToken(token: string) {
  sessionStorage.setItem(SESSION_KEY, token);
}

export const SessionsService = { getToken };
